export interface IRole {
    id_role: number
    id_professional: number
    default_level_permission: number
    name: string
    type_relatable: string
}

export const EmptyRole: {
    id_professional: number
    id_role: number
    default_level_permission: number
    name: string
    type_relatable: string
} = {
    id_professional: 0,
    id_role: 0,
    default_level_permission: 0,
    name: '',
    type_relatable: '',
}
